module.exports = __webpack_public_path__ + "img/dogsitting.fd504b16.svg";